import { isPauseActive } from './medicationPause';

export function isMedicationAlertTarget(medication, now = new Date()) {
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    // Ignore whole-group pause so the next alert method can be configured in advance.
    return medication.active !== false
        && medication.frequencyType !== 'AS_NEEDED'
        && (!medication.endDate || medication.endDate >= today)
        && !medication.paused
        && !isPauseActive(medication.pausedUntil, now);
}
